import React, { useEffect, useMemo, useRef, useState } from 'react';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { useFormContext } from '../FormContext';
const FormTimeField = ({ element, edit, disabled }) => {
    var _a, _b;
    const { formValues, setFormValue } = useFormContext();
    const key = element.dataSource || element.key;
    const [touched, setTouched] = useState(false);
    const [formValue, setValue] = useState(formValues[key] || null);
    const previousValueRef = useRef(formValue);
    const timeIncrement = ((_a = element.config) === null || _a === void 0 ? void 0 : _a.timeIncrement) || 1;
    const allowSeconds = ((_b = element.config) === null || _b === void 0 ? void 0 : _b.allowSeconds) || false;
    // refresh value if formValues change outside of the component
    useEffect(() => {
        if (formValues[key] && previousValueRef.current !== formValues[key]) {
            setValue(formValues[key]);
            previousValueRef.current = formValues[key];
        }
    }, [formValues, key]);
    const pickerView = allowSeconds
        ? ['hours', 'minutes', 'seconds']
        : ['hours', 'minutes'];
    const format = allowSeconds ? 'hh:mm:ss a' : 'hh:mm a';
    const value = useMemo(() => {
        if (!formValue || typeof formValue !== 'string') {
            return;
        }
        // include date with the input time value (formValue)
        const dateString = new Date()
            .toISOString()
            .split('T')
            .slice(0, 1)
            .concat(formValue)
            .join(' ');
        return new Date(dateString);
    }, [formValue]);
    // convert date to time string, also handle invalid dates
    const parseTime = (date) => {
        if (!date || !(date instanceof Date) || !isFinite(+date)) {
            return null;
        }
        // NOTE: taken from https://stackoverflow.com/a/8888498/7013346
        const hrs = date.getHours();
        const ampm = hrs >= 12 ? 'PM' : 'AM';
        const parts = [hrs % 12 || 12, date.getMinutes()];
        if (allowSeconds) {
            parts.push(date.getSeconds());
        }
        return parts
            .map(part => part.toString().padStart(2, '0'))
            .join(':')
            .concat(' ', ampm);
    };
    const updateFormValue = (date) => {
        // allow clearing value
        const parsed = parseTime(date);
        if (formValues[key] !== parsed) {
            setFormValue(key, parsed);
        }
    };
    const timePickerProps = {
    // TODO: Set minTime & maxTime
    // minTime :element.config?.minTime ,
    // maxTime: element.config?.maxTime
    };
    return (React.createElement(KeyboardTimePicker, Object.assign({ fullWidth: true, clearable: true, disabled: edit || disabled, inputVariant: 'outlined', minutesStep: timeIncrement, format: format, value: value || null, views: pickerView, onChange: (date, value) => {
            // fallback to input value to show invalid date for incomplete input
            setValue(parseTime(date) || value);
            setTouched(true);
        }, onAccept: (date) => updateFormValue(date), onBlur: () => touched && updateFormValue(value) }, timePickerProps)));
};
export default FormTimeField;
//# sourceMappingURL=FormTimeField.js.map